module.exports = __webpack_public_path__ + "../front/img/368med5hylder.a4ea5513.svg";